import { Component, OnInit, Input } from '@angular/core';

import { SessionsWeek, SessionsWeeksService } from '../../session-weeks.service';
import { camps } from '../../../../models/models.generated';
import { campsenum } from '../../../../models/enums.generated';

@Component({
    selector: 'app-acquired-sessions',
    templateUrl: './acquired-sessions.component.html',
    styleUrls: ['./acquired-sessions.component.scss'],
    standalone: false
})
export class AcquiredSessionsComponent implements OnInit {

    @Input()
    public purchase: camps.CampPurchaseDetails;

    public weeks: SessionsWeek[];

    constructor(private weekService: SessionsWeeksService) { }

    ngOnInit() {
        this.weeks = this.weekService.createSessionWeeks(this.purchase.sessions);
    }

    public  get allTheSessionsRefunded(){
        return this.purchase.isModification && (!this.purchase.sessions || this.purchase.sessions.length == 0);
    }

    public get title(){
        return campsenum.CampPurchaseStatus[this.purchase.status] != campsenum.CampPurchaseStatus.Refunded ? 'PurchaseDetails.acquiredSessions' : 'PurchaseDetails.refundedSessions';
    }
}
